const defaultValueStringHtml = '<p></p>';

export const ValidationsCleanStringHtml = (content) => {
  const cleanContent = content.replace(/\s/g, '');
  if (cleanContent === defaultValueStringHtml) {
    return true;
  }
  return false;
};

export const isEmptyHtml = (html) =>
  !html.replace(/<[^>]+>/g, '').replace(/ /g, '');

export const compareString = (str1, str2, caseSensitive = true) => {
  return caseSensitive
    ? str1.toLowerCase() === str2.toLowerCase()
    : str1 === str2;
};

export const isEqualString = (value, compare, caseSensitive = true) => {
  if (Array.isArray(compare)) {
    const val = compare.find((item) => {
      return compareString(value, item.pass, caseSensitive);
    });
    return !!val;
  } else if (typeof compare === 'string') {
    return compareString(value, compare, caseSensitive);
  }
  return false;
};
